import axios from 'axios';

export default axios.create({
    baseURL: 'https://api.unsplash.com',
    headers: {
        Authorization: 'Client-ID re_IAYP9rMuY2oERwBskG8brW8OgqNBuNyrhpMEShOs'
    }
});